import Link from "next/link"
import * as DropdownMenu from "@radix-ui/react-dropdown-menu"
import { usePaginatedQuery } from "@blitzjs/rpc"
import { Routes } from "@blitzjs/next"
import { useRouter } from "next/router"
import { StyledDropdownMenuContent, StyledDropdownMenuTrigger } from "components/elements"
import React, { useContext } from "react"
import * as Dialog from "@radix-ui/react-dialog"
import { PlusIcon } from "@radix-ui/react-icons"
import getScenarios from "app/scenarios/queries/getScenarios"
import { ScenarioDialog } from "./scenario_dialog"
import { CityContext } from "app/features/regional-map/regional-map.state"
import { City, Scenario } from "db"
import toast from "react-hot-toast"
import { scenarioIdEncode } from "app/utils/scenario_id"

const ITEMS_PER_PAGE = 100

export function ScenariosDropdown() {
  const router = useRouter()
  const page = Number(router.query.page) || 0
  const city = useContext(CityContext)!
  const [open, setOpen] = React.useState(false)
  const [menuOpen, menuSetOpen] = React.useState(false)
  const [{ scenarios }] = usePaginatedQuery(getScenarios, {
    where: { city: city.id.toUpperCase() as City },
    orderBy: { id: "asc" },
    skip: ITEMS_PER_PAGE * page,
    take: ITEMS_PER_PAGE,
  })
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Root open={menuOpen} onOpenChange={menuSetOpen}>
        <StyledDropdownMenuTrigger>Scenarios & reports</StyledDropdownMenuTrigger>
        <StyledDropdownMenuContent>
          <div className="divide-y divide-gray-200">
            {(scenarios as Scenario[]).length ? (
              (scenarios as Scenario[]).map((scenario: Scenario) => {
                return (
                  <DropdownMenu.Item className="px-2 py-2 text-sm" key={scenario.id}>
                    {scenario.name}
                    <div className="flex items-center gap-x-2">
                      <button
                        className="block cursor-pointer text-brand-green-dark transition-all hover:underline"
                        onClick={() => {
                          toast.dismiss()
                          menuSetOpen(false)
                          router.push(
                            Routes.Map({
                              scenarioId: scenarioIdEncode(scenario.id),
                              city: city.id,
                            })
                          )
                        }}
                      >
                        Scenario
                      </button>
                      <span className="text-brand-green-dark">|</span>
                      <Link
                        href={Routes.ReportPage({
                          id: scenarioIdEncode(scenario.id),
                          city: city.id,
                        })}
                        className="block cursor-pointer text-brand-green-dark transition-all hover:underline"
                        onClick={() => {
                          toast.dismiss()
                          menuSetOpen(false)
                        }}
                      >
                        Report
                      </Link>
                    </div>
                  </DropdownMenu.Item>
                )
              })
            ) : (
              <DropdownMenu.Label className="p-2 text-gray-500">
                No scenarios yet.
              </DropdownMenu.Label>
            )}
          </div>
          <DropdownMenu.Item asChild>
            <Dialog.Trigger className="mt-3 flex cursor-pointer items-center gap-x-1 px-2 py-1 text-xs font-semibold uppercase text-gray-500 hover:bg-gray-100 hover:outline-0">
              <PlusIcon />
              Create scenario
            </Dialog.Trigger>
          </DropdownMenu.Item>
          <DropdownMenu.Arrow className="fill-current text-white" />
        </StyledDropdownMenuContent>

        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50" />
        <ScenarioDialog close={() => setOpen(false)} />
      </DropdownMenu.Root>
    </Dialog.Root>
  )
}
